import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/container';

export const useProduct = (productId?: string) => {
    const { data: product, isLoading: isLoadingProduct } = useQuery({
        queryKey: ['product', productId],
        queryFn: async () => {
            if (!productId) throw new Error('Product ID is required');

            const result = await container.productRepository.getProduct(productId);
            if (result.status === 'error') throw new Error(result.error.message);
            return result.data;
        },
        enabled: !!productId,
        staleTime: 0,
        cacheTime: 0,
        refetchOnMount: 'always',
        refetchOnWindowFocus: true
    });

    return {
        product,
        isLoading: isLoadingProduct,
    };
}; 